'use strict';

export class Menuhorizontal {
	constructor(component_key) {
		this.id = component_key;
		this.init_dom();
	}

	init_dom() {
		this.$root = jQuery(`.js-${this.id}`);
		this.$wrap = this.$root.find('.js-wrap');
		this.$items = this.$root.find('.js-item');
		this.$selected = this.$root.find('.js-selected');
		this.$scroll_left = this.$root.find('.js-scroll_left');
		this.$scroll_right = this.$root.find('.js-scroll_right');
	}

	init() {
		this.init_dom();
		if (!this.$root.length) {
			return;
		}
		this.scroll_selected_into_view();
		this.init_scroll_buttons();
		this.init_keyboard_nav();

		jQuery(window).on('resize orientationchange', () => {
			this.on_resize();
		});

		setTimeout(() => {
			this.update_scroll_buttons();
		}, 100);

		this.add_events();
	}

	scroll_selected_into_view() {
		const selected_element = this.$selected[0] || this.$root.find('.js-selected')[0];
		if (selected_element) {
			selected_element.scrollIntoView({
				inline: 'center',
				block: 'nearest'
			});
		}
	}

	init_scroll_buttons() {
		if (!this.$scroll_left.length || !this.$scroll_right.length || !this.$wrap.length) {
			return;
		}

		this.update_scroll_buttons();

		this.$scroll_left.on('click', () => {
			const wrap = this.$wrap[0];
			if (wrap) {
				wrap.scrollBy({ left: -200, behavior: 'smooth' });
			}
		});

		this.$scroll_right.on('click', () => {
			const wrap = this.$wrap[0];
			if (wrap) {
				wrap.scrollBy({ left: 200, behavior: 'smooth' });
			}
		});

		this.$wrap.on('scroll', () => {
			this.update_scroll_buttons();
		});
	}

	update_scroll_buttons() {
		const wrap = this.$wrap[0];
		if (!wrap) {
			return;
		}

		const is_overflowing = wrap.scrollWidth > (wrap.clientWidth + 5);
		if (!is_overflowing) {
			this.$scroll_left.addClass('hidden');
			this.$scroll_right.addClass('hidden');
			return;
		}

		const is_at_start = wrap.scrollLeft <= 5;
		const is_at_end = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 5;

		this.$scroll_left.toggleClass('hidden', is_at_start);
		this.$scroll_right.toggleClass('hidden', is_at_end);
	}

	init_keyboard_nav() {
		this.$items.on('keydown', (e) => {
			if (e.key === 'ArrowRight') {
				const $next = jQuery(e.currentTarget).next('.js-item').find('a');
				if ($next.length) {
					$next.focus();
				}
			} else if (e.key === 'ArrowLeft') {
				const $prev = jQuery(e.currentTarget).prev('.js-item').find('a');
				if ($prev.length) {
					$prev.focus();
				}
			}
		});
	}

	on_resize() {
		this.scroll_selected_into_view();
		this.update_scroll_buttons();
	}

	add_events() {
		// Hook for subclasses
	}
}
